import { Link } from "react-router-dom";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  current: string;
}

export default function PageHero({ eyebrow, title, description, current }: PageHeroProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="container-page py-12 md:py-16">
        <nav
          aria-label="Fil d'ariane"
          className="animate-fade-in flex items-center gap-2 text-xs text-foreground-500"
        >
          <Link to="/" className="hover:text-foreground-800">
            Accueil
          </Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
          <span className="text-foreground-800">{current}</span>
        </nav>
        {eyebrow && (
          <span
            className="animate-fade-up mt-5 inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs font-label font-semibold uppercase tracking-wide text-accent-900"
            style={{ animationDelay: "60ms" }}
          >
            <i className="ri-map-pin-2-line text-[13px]" aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        <h1
          className="animate-fade-up mt-4 max-w-3xl text-3xl md:text-5xl font-heading font-semibold leading-tight text-foreground-950"
          style={{ animationDelay: "120ms" }}
        >
          {title}
        </h1>
        {description && (
          <p
            className="animate-fade-up mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600"
            style={{ animationDelay: "200ms" }}
          >
            {description}
          </p>
        )}
      </div>
    </section>
  );
}